import React, { useState } from 'react'
import { VoiceAgentCallMain } from '../../components/VoiceAgentCallMain'
import { AssessmentsProvider } from './context/AssessmentsProvider'
import { ShiftIdEntry } from './components/ShiftIdEntry'
import { ShiftIdDisplay } from './components/ShiftIdDisplay'

export const Assessments = () => {
  const [shiftId, setShiftId] = useState<number | null>(null)

  if (shiftId == null) {
    return <ShiftIdEntry onSubmit={setShiftId} />
  }

  return (
    <AssessmentsProvider shiftId={shiftId}>
      <VoiceAgentCallMain
        detailsContent={
          <ShiftIdDisplay shiftId={shiftId} onChange={() => setShiftId(null)} />
        }
      />
    </AssessmentsProvider>
  )
}
